import { Dialog, DialogContent, DialogTitle, DialogClose } from "@/components/ui/dialog";
import Pricing from "@/components/Pricing";
import { X } from "lucide-react";

interface AllAccessPlansDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Optional one-line note shown above the plans (e.g. why the user sees this). */
  subtitle?: string;
}

const AllAccessPlansDialog = ({ open, onOpenChange, subtitle }: AllAccessPlansDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideClose
        className="max-w-6xl w-[calc(100%-2rem)] sm:w-[95vw] max-h-[85vh] overflow-hidden rounded-2xl sm:rounded-3xl p-0 bg-background border shadow-2xl flex flex-col"
      >
        <DialogTitle className="sr-only">All-Access Plans</DialogTitle>
        <DialogClose className="absolute right-3 top-3 z-50 rounded-full bg-muted/80 p-2 text-foreground opacity-90 ring-offset-background transition-opacity hover:bg-muted hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
          <X className="h-6 w-6" />
          <span className="sr-only">Close</span>
        </DialogClose>
        <div className="overflow-y-auto flex-1 py-6 px-4 sm:py-8 sm:px-6">
          {subtitle && (
            <p className="mb-4 text-center text-sm md:text-base font-medium text-foreground">
              {subtitle}
            </p>
          )}
          <div className="rounded-2xl overflow-hidden bg-muted/30">
            <Pricing />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AllAccessPlansDialog;
